import type { Theme } from '@mui/material';

export const tablePaginationControlsStyles = {
  root: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    px: { xs: theme.spacing(1), sm: theme.spacing(1.5) },
    py: theme.spacing(1),
  }),
  rowsPerPage: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  }),
  label: {
    color: 'text.secondary',
    fontSize: '0.875rem',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
  },
  controls: (theme: Theme) => ({
    '& .MuiPagination-ul': {
      flexWrap: 'nowrap',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
  }),
  item: (theme: Theme) => ({
    minWidth: 32,
    width: 32,
    height: 32,
    margin: 0,
    borderRadius: '999px',
    border: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    fontSize: '1rem',
    lineHeight: '20px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary['200'],
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.primary['200'],
    },
    '&.MuiPaginationItem-previousNext': {
      minWidth: 32,
      width: 32,
      height: 32,
    },
    '&.Mui-disabled': {
      opacity: 0.4,
    },
  }),
} as const;
